import { create } from "zustand";
import { useVybeAuthStore } from "@/lib/vybe-auth/store";

interface VybeStudioStoreState {
  open: boolean;
  setOpen: (open: boolean) => void;
  requestOpen: () => void;
}

export const useVybeStudioStore = create<VybeStudioStoreState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
  // Admin-gated: Vybe Studio is a staff-only surface. Client-side UX gating
  // only — NOT a security boundary.
  requestOpen: () => {
    const isAdmin = !!useVybeAuthStore
      .getState()
      .user?.roles?.includes("Admin");
    if (!isAdmin) return;
    set({ open: true });
  },
}));
